import { AlertTriangle, Bell, Info } from 'lucide-react';
import { cn } from '@/lib/utils';
import { AnnouncementPriority } from '../types';

interface PriorityBadgeProps {
  priority: AnnouncementPriority;
  className?: string;
}

const STYLES: Record<AnnouncementPriority, { label: string; cls: string; Icon: typeof Info }> = {
  [AnnouncementPriority.Normal]: {
    label: 'Normal',
    cls: 'bg-muted text-muted-foreground border-border',
    Icon: Info,
  },
  [AnnouncementPriority.Important]: {
    label: 'Important',
    cls: 'bg-warning/10 text-warning border-warning/30',
    Icon: Bell,
  },
  [AnnouncementPriority.Critical]: {
    label: 'Critical',
    cls: 'bg-destructive/10 text-destructive border-destructive/30',
    Icon: AlertTriangle,
  },
};

export function PriorityBadge({ priority, className }: PriorityBadgeProps) {
  const { label, cls, Icon } = STYLES[priority];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium',
        cls,
        className
      )}
    >
      <Icon className="h-3 w-3" />
      {label}
    </span>
  );
}
